// extracted by mini-css-extract-plugin
export var fluidImage = "fluid-image-module--fluid-image--af441";
export var precomposed = "fluid-image-module--precomposed--2cad8";